// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"243fe43f","703":"27a76283","787":"898bfd65"}[chunkId] + ".chunk.js";
};